import { render, staticRenderFns } from "./CollectionAddNew.vue?vue&type=template&id=01e90c22&"
import script from "./CollectionAddNew.vue?vue&type=script&lang=js&"
export * from "./CollectionAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports